export const snapshotLanguage = {
  title: "Your Friction Snapshot" as const,
  desiredStateHeading: "What better looks like" as const,
  nextStepHeading: "What happens next" as const,
  fixing: {
    intent: "Fixing Today" as const,
    impactHeading: "Current impact",
    impactPrefix: "The current impact is",
    nextStep: "You have identified this as an active issue. The next useful step is to understand where the friction begins, what keeps it in place and what else it affects.",
  },
  planning: {
    intent: "Planning for Tomorrow" as const,
    impactHeading: "Risk being anticipated",
    impactPrefix: "The risk you are planning around is",
    nextStep: "You have identified this before it becomes more disruptive. The next useful step is to understand where it could constrain growth, what would trigger that pressure and what should be strengthened first.",
  },
};

export const prohibitedSnapshotPhrases = [
  "We recommend",
  "You should",
  "The solution is",
  "The root cause is",
  "Your score",
  "Your maturity",
  "Your business is failing",
  "Your systems are outdated",
  "You need HuddleCo",
  "This proves",
  "This confirms",
  "Based on industry benchmarks",
  "Most businesses like yours",
] as const;
